import React from 'react';
import { DEFAULT_REMOTE_CONFIG_FLAGS } from './featureFlags.const';

const FlagsContext = React.createContext(DEFAULT_REMOTE_CONFIG_FLAGS);

export default FlagsContext;
